import React, { Component } from "react";

import { v1, v4 } from "uuid";
import axios from "axios";
import _ from "lodash";
import PropsType from "prop-types";
import { Typography, Box } from "@mui/material";

import ZChat from "Components/ZChat/ZChat";
import { Chatbot, ChatDOMAIN, DOMAIN, QA_DOMAIN } from "config/config";

import { VStack } from "Components/LabIZO/Stackizo";
import { Accessor, store, ErrorX, ColorX } from "static";
import MuiAlert from "@mui/material/Alert";
import Snackbar from "@mui/material/Snackbar";

import { observer } from "mobx-react";
import "./Messenger.scss";
import { Analyzer } from "Components/Talk2GPTDetails/Analzyer";
import { backendConnector } from "connectors";
class Messenger extends Component {
  static propTypes = {
    url: PropsType.string,
    urlParams: PropsType.object,
    streamUrl: PropsType.string,
    followupQuestionUrl: PropsType.string,
    historyUrl: PropsType.string,
    project: PropsType.string,
    userId: PropsType.string,
    onMounted: PropsType.func,
    LiveChatEnabled: PropsType.bool,
    onMsgRecieved: PropsType.func,
    onMsgSelected: PropsType.func,
    viaBackend: PropsType.bool,

    //zchat
    hideLongAnswer: PropsType.bool,
    revertReadMore: PropsType.bool,
    buttonWidthFitContent: PropsType.bool,

    pressEnterToSend: PropsType.bool,
    animated: PropsType.bool,

    showHeader: PropsType.bool,
    showFooter: PropsType.bool,
    showStatus: PropsType.bool,
    showDateTime: PropsType.bool,
    showLapseTime: PropsType.bool,

    showInAvatar: PropsType.bool,
    showOutAvatar: PropsType.bool,
    hideSameAvatar: PropsType.bool,
    avatarAtTop: PropsType.bool,

    appendTextAfterSend: PropsType.bool,
    quickReplyBar: PropsType.bool,
    showQuickRepliesAsButtons: PropsType.bool,
    disableButtonsAfterSend: PropsType.bool,
    disableTemplateButtonsAfterSend: PropsType.bool,

    canClickOnIn: PropsType.bool,
    canClickOnOut: PropsType.bool,
    HTMLEnabled: PropsType.bool,
    onMsgSent: PropsType.func,
    onClearHostory: PropsType.func,
  };

  static defaultProps = {
    url: "",
    streamOutput: false,
    streamUrl: "",
    followupQuestionUrl: "",
    historyUrl: "",
    name: "Talk to Virtual Assistant",
    onMounted: null,
    LiveChatEnabled: false,
    onMsgRecieved: null,
    onMsgSelected: null,
    viaBackend: true,

    //zchat
    hideLongAnswer: false,
    revertReadMore: true,
    buttonWidthFitContent: true,

    pressEnterToSend: true,
    animated: true,

    showHeader: false,
    showFooter: true,
    showStatus: false,
    showDateTime: true,
    showLapseTime: true,

    showInAvatar: true,
    showOutAvatar: false,
    hideSameAvatar: true,
    avatarAtTop: false,

    appendTextAfterSend: true,
    quickReplyBar: true,
    showQuickRepliesAsButtons: true,
    disableButtonsAfterSend: true,
    disableTemplateButtonsAfterSend: false,

    canClickOnIn: false,
    canClickOnOut: true,
    HTMLEnabled: true,
  };

  constructor() {
    super();
    this.state = {
      isStreaming: false,
      analyzer: new Analyzer(),
      zchat: {
        hideLongAnswer: false,
        revertReadMore: true,
        buttonWidthFitContent: true,

        pressEnterToSend: true,
        animated: true,

        showHeader: false,
        showFooter: true,
        showStatus: false,
        showDateTime: true,
        showLapseTime: true,

        showInAvatar: true,
        showOutAvatar: false,
        hideSameAvatar: true,
        avatarAtTop: false,

        appendTextAfterSend: true,
        quickReplyBar: true,
        showQuickRepliesAsButtons: true,
        disableButtonsAfterSend: true,
        disableTemplateButtonsAfterSend: false,

        canClickOnIn: false,
        canClickOnOut: true,
        HTMLEnabled: true,
      },
    };
  }

  componentDidMount() {
    this._setAllStates(() => {
      this._setChatbot(() => {
        this._regenSession();
        this._setUserId();
      });
    });

    //get page url param
    const searchParams = new URLSearchParams(window.location.search);
    const urlParams = Object.fromEntries([...searchParams.entries()].map(([key, value]) => [key, value]));
    console.log("URL parameters: ", urlParams);

    this.setState({
      urlParams: urlParams,
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (!Accessor.IsIdentical(prevProps, this.props, Object.keys(Messenger.defaultProps))) {
      this._setAllStates();
    }
  }

  componentWillUnmount() {
    this.setState = (state, callback) => {
      return;
    };
  }

  _setAllStates = (callback) => {
    this.setState(
      (state, props) => ({
        ...props,
      }),
      () => {
        if (this.props.onMounted) {
          this.props.onMounted({
            setChatbot: this._setChatbot,
            regenSession: this._regenSession,
            restartChat: this._restartChat,
            welcomeMessage: this._welcomeMessage,
            onSendAppend: this.onSendAppend,
          });
        }
        if (callback) callback();
      }
    );
  };

  onMountChat = (callbacks) => {
    this.MountChat = callbacks;
  };

  _setUserId = (userId) => {
    if (!userId) userId = this._getUserId();
    this.setState({
      userId: userId,
    });
  };

  _getUserId = () => {
    let { userId } = this.props;
    if (userId) return userId;
    return "talk2va";
  };

  _getURL = () => {
    let { viaBackend, url } = this.props;
    if (url) return url;
    return viaBackend ? DOMAIN + "/Middleware/Message/Send" : ChatDOMAIN + "/Talk2VA";
  };

  _setChatbot = (callback) => {
    console.log("[-] START CHATBOT");

    let { interval, version, channel } = Chatbot;
    let url = this._getURL();

    this.setState(
      {
        livechat: false,
        channel: channel,
        url: url,
        timeout: interval,
        sending: false,
        version: version,
      },
      callback
    );
  };

  _regenSession = () => {
    this.setState(
      {
        sessionID: v1(),
      },
      () => {
        this._restartChat();
      }
    );
  };

  _restartChat = () => {
    this.MountChat.Clear();
    this._welcomeMessage();
  };

  _clearHistory = () => {
    this.setState(
      {
        sessionID: v1(),
      },
      () => {
        this.MountChat.LinkBreak();
        this._welcomeMessage();
      }
    );
  };

  _welcomeMessage = () => {
    let input = {
      type: "system",
      content: "CMD_WELCOME",
    };

    const searchParams = new URLSearchParams(document.location.search);
    this.sendToServer(input, v4(), undefined, searchParams.get("lang"));
  };

  onSend = (input, id) => {
    let inputO = {
      type: "text",
      content: input.text,
    };

    this.sendToServer(inputO, id, true);
  };

  onSendAppend = (text) => {
    let { sessionID } = this.state;
    let inputO = {
      type: "text",
      content: text,
    };
    this.MountChat.AppendText(text);
    this.sendToServer(inputO, sessionID, true);
  };

  onQuickReply = (quickReply, id) => {
    let input = {
      type: "button",
      content: quickReply.payload,
    };
    this.sendToServer(input, id, true);
  };

  onMsgLongPress = (msgId, msg) => {
    console.log("messenger.onMsgLongPress", msgId, msg);
    const record = this.state?.analyzer?.findRecord(msg.text);
    let { onMsgSelected } = this.props;
    if (onMsgSelected) {
      onMsgSelected(msgId, msg, record.addOns);
    }
  };

  onClearHostory = async () => {
    let { historyUrl, sessionID } = this.state;
    let payload = {
      JWT: store.user.JWT,
      sessionID: sessionID,
    };
    await axios.post(historyUrl, payload);
    this._clearHistory();
  };

  sendToServer = async (input, _id, record = false, lang) => {
    let { url, sessionID, channel, version, livechat, urlParams } = this.state;
    let { onMsgRecieved, viaBackend, project } = this.props;
    const { userId } = this.state;
    let startTime = new Date();
    let payloadOut;

    if (viaBackend) {
      payloadOut = {
        JWT: store.user.JWT,
        env: store.server.Env,
        data: {
          user_id: userId,
          session_id: sessionID,
          message_id: _id,
          channel: channel,
          urlParams: urlParams,
          project: project,
          input: input,
          lang: lang,
          livechat: livechat,
          timestamp: new Date(),
          remarks: {
            version: version,
          },
        },
      };
    } else {
      payloadOut = {
        user_id: userId,
        session_id: sessionID,
        message_id: _id,
        channel: channel,
        urlParams: urlParams,
        project: project,
        input: input,
        lang: lang,
        livechat: livechat,
        timestamp: new Date(),
        remarks: {
          version: version,
        },
      };
    }

    console.log("[>] Data Sent: " + startTime, payloadOut);

    try {
      this.MountChat.Typing();

      const { streamOutput, streamUrl, referenceUrl } = this.state;
      const { followupQuestionUrl } = this.props;

      let res = null;

      if (streamOutput) {
        // this.setState({ isStreaming: true });
        if (!streamUrl) {
          console.log("[-] streamUrl is not defined");
          return;
        }
        if (!this.MountChat.SetMsg) return;

        const checkStreaming = async () => {
          const { isStreaming } = this.state;
          if (isStreaming) {
            // wait 1 sec
            this.MountChat.Typing();
            await new Promise((resolve) => setTimeout(resolve, 100));
            console.log("[-] isStreaming in checkStreaming: ", isStreaming);
            // recall checking after timeout
            await checkStreaming();
          } else {
            const streamFinishCallback = async () => {
              this.setState({ isStreaming: true });
              console.log("[-] isStreaming in streamFinishCallback: ", isStreaming);

              const { data: connectStreamRes } = await axios.post(url, payloadOut);
              const { response_id, message } = connectStreamRes.payload;
              const msgMeta = (message && message[0]?.msg) ?? {};

              if (!_.includes(payloadOut.data.input.content, "CMD")) this.state.analyzer?.addRecord(payloadOut.data.input.content, connectStreamRes.payload);

              const getGPTResponseChunk = async (responseId, prevChunk = "", noMsgCount = 0) => {
                try {
                  if (!responseId) return;
                  const { data: chunk } = await axios.post(streamUrl, {
                    ...payloadOut,
                    data: {
                      response_id: responseId,
                      prev_chunk: prevChunk,
                    },
                  });

                  const msg = chunk?.payload?.message && chunk?.payload?.message[0];
                  if (!msg) return;

                  if (msg?.msg.text == "") {
                    noMsgCount++;
                    if (noMsgCount > 10) {
                      console.error("No message received from model, breakig loop, try asking something else");
                      return;
                    }
                  }
                  this.MountChat.SetMsg(
                    {
                      ...msg,
                      msg: {
                        ...msg.msg,
                        ...msgMeta,
                      },
                    },
                    _id,
                    2
                  );

                  await getGPTResponseChunk(responseId, msg?.msg?.text ?? "", noMsgCount);
                } catch (e) {
                  console.log(e);
                }
              };

              this.appendReturnMessage([{ msg: { text: "🧠" }, user: { _id: 2 } }], _id);
              this.MountChat.Typing(false);

              await getGPTResponseChunk(response_id);

              const isWelcomeMessage = payloadOut.data.input.content === "CMD_WELCOME";

              if (referenceUrl && !isWelcomeMessage) {
                const referenceData = await axios.post(referenceUrl, {
                  ...payloadOut,
                  data: {
                    response_id: response_id,
                  },
                });
                this.MountChat.AppendRef(referenceData);
              }

              if (followupQuestionUrl && !isWelcomeMessage) {
                const followupQuestionData = await axios.post(followupQuestionUrl, { ...payloadOut, data: { response_id: response_id } });
                let { Success, payload } = followupQuestionData.data;
                if (Success) {
                  this.MountChat.SetQuickReplies(
                    payload.map((followupQuestion) => {
                      return {
                        title: followupQuestion,
                        payload: followupQuestion,
                      };
                    })
                  );
                }
              }

              if (this.props.onMsgSent) this.props.onMsgSent(connectStreamRes.payload, _id, connectStreamRes.payload.message);

              return;
            };
            await streamFinishCallback();
            this.setState({ isStreaming: false });
          }
        };
        await checkStreaming();
        this.MountChat.Typing(false);
      } else {
        res = await axios.post(url, payloadOut);

        if (res && res.data?.Success === true) {
          //  Cannot read properties of null (reading 'data')
          let endTime = new Date();
          if (_id) this.MountChat.SetStatus(_id, "received");

          if (payloadOut.data?.input && !_.includes(payloadOut.data.input.content, "CMD")) this.state.analyzer?.addRecord(payloadOut.data.input.content, res.data.payload);

          let processTime = (endTime - startTime) / 1000;
          console.log("[<] Data Received: " + endTime);
          console.log("[-] Process Time: " + processTime + "s");
          console.log("[-] MW Response: ", res.data);

          let payload;
          if (viaBackend) {
            payload = res?.data.payload;
          } else {
            payload = res?.data;
          }

          let payloadOutR;
          if (viaBackend) {
            payloadOutR = payloadOut.data;
          } else {
            payloadOutR = payloadOut;
          }

          if (record && onMsgRecieved) {
            onMsgRecieved(payloadOutR, payload, startTime, endTime, _id, version);
          }

          if (payload.live_chat) this.startLiveChatPoll();
          else this.stopLiveChatPoll();

          let msg = payload.message;

          _.map(msg, (o, i) => {
            o.lapseTime = processTime;
          });

          this.appendReturnMessage(msg, _id);
          if (this.props.onMsgSent) this.props.onMsgSent(payload, _id, msg);
          this.MountChat.Typing(false);
        } else {
          let payload;
          if (viaBackend) {
            payload = res?.data?.payload;
          } else {
            payload = res?.data;
          }
          ErrorX.Handle(payload);
        }
      }
    } catch (e) {
      this.MountChat.Typing(false);
      console.error(e);
      ErrorX.Handle(e);
      if (_id) this.MountChat.SetStatus(_id, "pending");
    }
  };

  appendReturnMessage = (messages, _id) => {
    messages.forEach((o, i) => (o._id = o._id ?? _id));
    this.MountChat.Append(messages.reverse());
    this.MountChat.SetStatus(_id, "read");
  };

  setReturnMessage = (messages, _id) => {
    this.MountChat.Set(messages.reverse());
  };

  liveChatShoot = () => {
    let { url, sessionID, channel, count, timeout, livechat, sending, remarks, urlParams } = this.state;
    let { viaBackend } = this.props;

    if (!livechat || sending) return;
    //Send Message to MW
    let date = Math.round(new Date().getTime() / 1000);
    let payloadOut;

    if (viaBackend) {
      payloadOut = {
        JWT: store.user.JWT,
        data: {
          session_id: sessionID,
          channel: channel,
          livechat: livechat,
          urlParams: urlParams,
          input: {
            type: "system",
            content: "CMD_POLLING",
          },
          timestamp: date,
          remarks: remarks,
        },
      };
    } else {
      payloadOut = {
        session_id: sessionID,
        channel: channel,
        livechat: livechat,
        urlParams: urlParams,
        input: {
          type: "system",
          content: "CMD_POLLING",
        },
        timestamp: date,
        remarks: remarks,
      };
    }

    this.setState(
      {
        sending: true,
        count: count + 1,
      },
      async () => {
        console.log("[>] LiveChat Bullet Sent. Count:" + count);

        try {
          let res = await axios.post(url, payloadOut);
          console.log("[<] Bullet Received.", res.data);
          this.setState({ sending: false });

          let { Success } = res.data;
          let payload;
          if (viaBackend) {
            payload = res.data.payload;
          } else {
            payload = res.data;
          }
          if (Success && !_.isEmpty(payload.message)) {
            console.log("[<] Message Received.");
            this.setState({ count: 0 });
            this.appendReturnMessage(payload.message);

            if (payload.live_chat) {
              setTimeout(() => {
                this.liveChatShoot();
              }, timeout);
            }
          } else this.stopLiveChatPoll();
        } catch (e) {
          console.log(e);
          this.setState(
            {
              sending: false,
            },
            () => {
              this.liveChatShoot();
            }
          );
        }
      }
    );
  };

  startLiveChatPoll = () => {
    let { LiveChatEnabled } = this.props;
    if (!LiveChatEnabled) return;
    console.log("[-] Live Chat Start Polling");
    this.setState(
      {
        livechat: true,
      },
      () => {
        this.liveChatShoot();
      }
    );
  };

  stopLiveChatPoll = () => {
    console.log("[-] Live Chat Stop Polling");
    this.setState({
      livechat: false,
    });
  };

  onCardBTNPress = async (o) => {
    try {
      await axios.post(`${QA_DOMAIN}/train`, o.payload);

      this.setState({
        sbopen: true,
        sbmsg: `Suggested answer: ${o.payload.suggested}`,
        sbseverity: "success",
      });
    } catch (e) {
      console.error(e);
      this.setState({
        sbopen: true,
        sbmsg: "Could not save record",
        sbseverity: "error",
      });
    }
  };

  CloseSB = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    this.setState({ sbopen: false });
  };

  renderChat() {
    let zchat = Accessor.Exclude(this.state, ["onMounted", "LiveChatEnabled", "onMsgRecieved", "onMsgSelected", "viaBackend"]);

    const Alert = React.forwardRef(function Alert(props, ref) {
      return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
    });
    return (
      <Box className="t2va-chat" sx={{ width: "100%", height: "calc(100% - 50px)", paddingBottom: "0", pt: "0px" }}>
        <ZChat
          cssPrefix=""
          browser={store.browser}
          onMounted={this.onMountChat}
          onSend={this.onSend}
          onQuickReply={this.onQuickReply}
          onCardBTNPress={this.onCardBTNPress}
          onMsgLongPress={this.onMsgLongPress}
          onMsgPress={this.onMsgLongPress}
          onClearHostory={this.onClearHostory}
          user={{
            _id: 1,
          }}
          {...zchat}
        />
        <Snackbar anchorOrigin={{ vertical: "bottom", horizontal: "center" }} open={this.state.sbopen} autoHideDuration={6000} onClose={this.CloseSB}>
          <Alert onClose={this.CloseSB} severity={this.state.sbseverity} sx={{ width: "100%" }}>
            {this.state.sbmsg}
          </Alert>
        </Snackbar>
      </Box>
    );
  }

  renderLink() {
    return (
      <Box>
        <Typography
          style={{
            color: ColorX.GetColorCSS("Primary"),
            fontSize: 9,
            width: "100%",
            paddingTop: "60px",
            position: "fixed",
          }}
        >
          {/* {"Connecting >>> " + this._getURL()} */}
        </Typography>
      </Box>
    );
  }

  renderHeader() {
    return (
      <div className="headline">
        <Box className="left">
          <div className={"syva_logo"}></div>
        </Box>

        <div className="text">{this.state.name}</div>

        <Box className="right"></Box>
      </div>
    );
  }

  render() {
    return (
      <VStack sx={{ width: "100%", minHeight: "calc(100%)", height: "100%", background: "#fff" }}>
        {this.props.header ? this.props.header : this.renderHeader()}
        {this.renderLink()}
        {this.renderChat()}
      </VStack>
    );
  }
}

export default observer(Messenger);
